import { AppointmentModel } from '../models/appointment.model';

export class CheckinResultModel {
    appointments: AppointmentModel[];
    customMessage: string;
    status: string;
    patientFullName: string;
    patientFirstName: string;
    patientLastName: string;

    constructor(appointments: AppointmentModel[] = [], customMessage: string = '', status: string = '', patientFirstName = '', patientLastName = '') {
        this.appointments = appointments;
        this.customMessage = customMessage;
        this.status = status;
        this.patientFullName = patientFirstName + " " + patientLastName;
        this.patientFirstName = patientFirstName;
        this.patientLastName = patientLastName;
    }
}
